<template>
  <div>
    <navigation></navigation>
    <message></message>
    <panel v-if="isLoggedIn"></panel>
    <router-view></router-view>
    <bottom-bar></bottom-bar>
  </div>
</template>

<script>
  import Navigation from "../components/Navigation";
  import TopBar from "../components/TopBar";
  import Message from "../components/Message";
  import Panel from "../components/Panel";
  import BottomBar from "../components/BottomBar";
  import {CHECK_TOKEN_AFTER_RELOAD} from '../store/actions'
  import {mapGetters} from 'vuex';
  import jQuery from "jquery";

  export default {
    name: 'app',
    components: {Panel, Message, TopBar, Navigation, BottomBar},
    data() {
      return {
        msg: 'Welcome to Your Vue.js App'
      }
    },
    mounted() {
      this.$store.dispatch(CHECK_TOKEN_AFTER_RELOAD);

      jQuery(function () {
        jQuery('[data-toggle="popover"]').popover();
      })
    },
    computed: {
      ...mapGetters(['isLoggedIn']),
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/App.vue